module.exports = __webpack_public_path__ + "static/media/connection-green-icon.17afa3f6.svg";